import fire from './fire.svg';
import plus from './plus.svg';

export const images = { fire, plus };
